/**
 * CMG Install-Only gate
 * ---------------------
 * On the product.install-only template, blocks add-to-cart until the
 * "installation service only" checkbox is confirmed.
 *
 * Mechanism: toggling the checkbox sets aria-disabled on the submit button.
 * Dawn's product-form.js onSubmitHandler already returns early when
 * aria-disabled === 'true', so no /cart/add.js fetch fires while unchecked —
 * this covers both the click and Enter-to-submit paths without racing Dawn's
 * own submit listener. A click on the locked button reveals the inline error
 * and moves focus to the checkbox.
 *
 * Fails open: if this script never loads, the button behaves normally. The
 * checkbox is an expectation-setting gate, not security.
 */
(function () {
  function initForm(form) {
    var checkbox = form.querySelector('[data-cmg-install-checkbox]');
    var submit = form.querySelector('[type="submit"][name="add"]');
    if (!checkbox || !submit) return;

    var wrapper = form.querySelector('[data-cmg-install-confirm]');
    var error = wrapper ? wrapper.querySelector('.cmg-install-confirm__error') : null;

    function lock() {
      submit.setAttribute('aria-disabled', 'true');
      submit.classList.add('cmg-install-gate--locked');
    }
    function unlock() {
      submit.setAttribute('aria-disabled', 'false');
      submit.classList.remove('cmg-install-gate--locked');
      hideError();
    }
    function showError() {
      if (error) error.hidden = false;
      if (wrapper) wrapper.classList.add('cmg-install-confirm--invalid');
    }
    function hideError() {
      if (error) error.hidden = true;
      if (wrapper) wrapper.classList.remove('cmg-install-confirm--invalid');
    }

    // Initial state reflects the checkbox (unchecked on load = locked).
    if (checkbox.checked) {
      unlock();
    } else {
      lock();
    }

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        unlock();
      } else {
        lock();
      }
    });

    // Surface the reason when a shopper clicks the locked button. Dawn has
    // already prevented the add via the aria-disabled guard; we only explain.
    submit.addEventListener('click', function () {
      if (!checkbox.checked) {
        showError();
        checkbox.focus();
      }
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-cmg-install-confirm]');
    forms.forEach(function (confirm) {
      var form = confirm.closest('form');
      if (form) initForm(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
